export const CONTAINER_FETCH = "CONTAINER_FETCH";
export const CONTAINER_FETCH_SUCCESS = "CONTAINER_FETCH_SUCCESS";
export const CONTAINER_FETCH_NEXT = "CONTAINER_FETCH_NEXT";
export const CONTAINER_FETCH_NEXT_SUCCESS = "CONTAINER_FETCH_NEXT_SUCCESS";
export const CONTAINER_RESET = "CONTAINER_RESET";
